import React from 'react';
import { StyleSheet } from 'react-native';

import CachedImage from '@components/CachedImage/CachedImage';
import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import { LocalFile, Team } from '@graphql/generated';
import theme from '@themes/theme';

const AVATAR_SIZE = 32;
const styles = StyleSheet.create({
  avatarSlot: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    minWidth: AVATAR_SIZE,
    minHeight: AVATAR_SIZE,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

interface TeamSummaryRowProps {
  team?: Team;
  teamName?: string;
  label?: string;
}

export const TeamSummaryRow: React.FC<TeamSummaryRowProps> = ({
  team,
  teamName,
  label = 'Team',
}) => {
  return (
    <Box my='m'>
      <Text mb='xs' variant='labelSmall' color='textPrimary'>
        {label}
      </Text>
      <Box
        flexDirection='row'
        alignItems='center'
        justifyContent='center'
        borderColor='grey03'
        backgroundColor='grey01'
        borderWidth={1}
        borderRadius='xs'
        height={48}
        mb='s'>
        <Box style={styles.avatarSlot}>
          {team?.avatarFile ? (
            <CachedImage
              avatarId={team.avatarFile.id}
              avatarType='team'
              image={team.avatarFile as unknown as LocalFile}
              width={AVATAR_SIZE}
              height={AVATAR_SIZE}
              borderRadius={theme.spacing.xs}
            />
          ) : (
            <Icon name='TT32' width={AVATAR_SIZE} height={AVATAR_SIZE} />
          )}
        </Box>

        <Text
          mx='xs'
          variant='labelSmall'
          color='textSecondary'
          numberOfLines={1}>
          {team?.name ?? teamName}
        </Text>
      </Box>
    </Box>
  );
};
